import React from 'react'
import { REQUIRED_MESSAGE } from '@Const/error-messages'
import { get, useFormState } from 'react-hook-form'

interface FieldErrorSectionFormProps {
    name: string
    assistiveText?: string
    required?: boolean
    visibility?: { errors?: boolean; assistive?: boolean }
}

const FieldErrorSectionForm = (props: FieldErrorSectionFormProps) => {
    const formState = useFormState()
    const { assistiveText, required, visibility = { errors: true, assistive: true }, name } = props

    const error = get(formState.errors, name)

    return (
        <>
            {error && visibility.errors ? (
                <p className="error-text small">{error.message}</p>
            ) : (
                <>
                    {visibility.assistive && (
                        <p className="assistive-text small">
                            {assistiveText ? assistiveText : required ? REQUIRED_MESSAGE : 'Optional'}
                        </p>
                    )}
                </>
            )}
        </>
    )
}

export default FieldErrorSectionForm
